import { Tag, Typography } from 'antd';
import tw from 'twin.macro';

import { USER_ROLE } from '@/constants';
import { useMe } from '@/hooks/queries/universal';

const Account = () => {
  const getMe = useMe();

  if (!getMe.data) {
    return null;
  }

  const { data } = getMe;

  return (
    <div css={tw`flex flex-row items-center gap-[8px]`}>
      <Tag color={data.userRole === 'ADMIN' ? 'green' : 'blue'}>
        {USER_ROLE[data.userRole] ?? data.userRole}
      </Tag>
      <Typography.Text ellipsis>{data.email}</Typography.Text>
    </div>
  );
};

export default Account;
